"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Ajax = _interopRequireDefault(require("./utils/Ajax"));

var PostListings = /*#__PURE__*/function () {
  function PostListings() {
    (0, _classCallCheck2.default)(this, PostListings);
  }

  (0, _createClass2.default)(PostListings, [{
    key: "populateListingFeed",
    value: function populateListingFeed(options) {
      var postListing = document.querySelector(".hs-hash-" + options.id);
      var listing_url = options.listing_url;

      if (window.document.URL) {
        listing_url += "&currentUrl=" + window.encodeURIComponent(window.document.URL);
      }

      if (window.document.referrer) {
        listing_url += "&referrer=" + window.encodeURIComponent(window.document.referrer);
      }

      _Ajax.default.get(listing_url, function (data) {
        if (postListing.children.length) {
          return;
        }

        data.forEach(function (row) {
          var showFeaturedImage = options.include_featured_image && row.featuredImage;
          var imageHtml = showFeaturedImage ? "\n              <img src=\"" + row.featuredImage + "\" alt=\"" + row.featuredImageAltText + "\">\n            " : '';
          var html = "\n              <li class=\"hs-postlisting-item\">\n                " + imageHtml + "\n                <a href=\"" + row.url + "\">" + row.label + "</a>\n              </li>\n            ";
          postListing.insertAdjacentHTML('beforeend', html);
        });
      });

      if (typeof hsPostListingComplete === 'function') {
        window.hsPostListingComplete(postListing);
      }
    }
  }]);
  return PostListings;
}();

window.hsPostListings = new PostListings();
window.hsPopulateListingFeed = window.hsPostListings.populateListingFeed;


//////////////////
// WEBPACK FOOTER
// ./js/post_listing_asset.js
// module id = 5
// module chunks = 2